import { create } from 'zustand';

export interface RecentClient {
  spireId: number;
  name: string;
}
export interface RecentItem {
  spireId: number;
  partNo: string;
  description: string | null;
}

interface RecentState {
  clients: RecentClient[];
  items: RecentItem[];
  pushClient: (c: RecentClient) => void;
  pushItem: (i: RecentItem) => void;
}

const KEY = 'kdental:recent';
const MAX = 8;

function load(): { clients: RecentClient[]; items: RecentItem[] } {
  if (typeof window === 'undefined') return { clients: [], items: [] };
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as { clients: RecentClient[]; items: RecentItem[] }) : { clients: [], items: [] };
  } catch {
    return { clients: [], items: [] };
  }
}
function persist(state: { clients: RecentClient[]; items: RecentItem[] }): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ clients: state.clients, items: state.items }));
  } catch {
    /* ignore */
  }
}

const initial = load();

/** Most-recent-first, deduped by spireId, capped at MAX. */
function bump<T extends { spireId: number }>(list: T[], entry: T): T[] {
  return [entry, ...list.filter((x) => x.spireId !== entry.spireId)].slice(0, MAX);
}

export const useRecent = create<RecentState>((set, get) => ({
  clients: initial.clients,
  items: initial.items,
  pushClient(c) {
    const clients = bump(get().clients, c);
    set({ clients });
    persist({ clients, items: get().items });
  },
  pushItem(i) {
    const items = bump(get().items, i);
    set({ items });
    persist({ clients: get().clients, items });
  },
}));
